import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@pt/environment';
import { getQueryParams } from '@hglobal/common';
import { Observable } from 'rxjs';

import {
  GetMyMentoringRes, GetTaskDetailsReq, GetTaskDetailsRes, PostMyMentoringTaskReq,
} from '../models';
import { MyMentoringApi } from './my-mentoring-api.interface';

@Injectable()
export class MyMentoringApiService implements MyMentoringApi {
  readonly #httpClient = inject(HttpClient);
  readonly #baseUrl = `${environment.apiHost}mentoring/my-mentoring/`;

  getMentoring(): Observable<GetMyMentoringRes> {
    return this.#httpClient.get<GetMyMentoringRes>(this.#baseUrl);
  }

  getTaskDetails({ taskId }: GetTaskDetailsReq): Observable<GetTaskDetailsRes> {
    return this.#httpClient.get<GetTaskDetailsRes>(
      `${this.#baseUrl}tasks/`,
      { params: getQueryParams({ taskId }) },
    );
  }

  postCompleteTasks(params: PostMyMentoringTaskReq): Observable<void> {
    return this.#httpClient.post<void>(`${this.#baseUrl}tasks/`, params);
  }
}
